import React, { useRef } from 'react';
import SearchBar, { ISearchBar } from '../SearchBar/SearchBar';
import { DropdownWrapper, SearchBarDropdownWrapper } from './SearchBarDropdown.styled';
import Dropdown, { IDropdown } from '../Dropdown/Dropdown';
import { useClickOutside } from '@emarketer/componentlibrary';

export interface ISearchBarDropdown extends ISearchBar, IDropdown {
  show?: boolean;
  callback: any;
}

const SearchBarDropdown: React.FC<ISearchBarDropdown> = (props) => {
  const { show, items, maxItems, maxHeight, callback } = props;
  const ref = useRef(null);
  const [isFocused, setIsFocused] = React.useState(false);
  useClickOutside(ref, () => setIsFocused(false));
  const showDropdown = show ? show : props.items && props.items.length > 0 && isFocused;

  const handleCallback = (item) => {
    callback(item);
    setIsFocused(false);
  };

  return (
    <SearchBarDropdownWrapper ref={ref} onFocus={() => setIsFocused(true)}>
      <SearchBar {...props} />
      {showDropdown && (
        <DropdownWrapper>
          <Dropdown callback={handleCallback} items={items} maxItems={maxItems} maxHeight={maxHeight} />
        </DropdownWrapper>
      )}
    </SearchBarDropdownWrapper>
  );
};

export default SearchBarDropdown;
